module.exports = __webpack_public_path__ + "assets/a78389b1762ffe1b1f42c2976867d4b5.mp3";